<template>
  <div>
    <top-header></top-header>
    <b-container class="mt-5">
      <b-row>
        <b-col class="px-3 text-left">
          <div class="heading">About Us</div>
        </b-col>
      </b-row>
    </b-container>
    <div class="about-team py-3">
      <b-container class="mb-3 text-left">
        <p class="text-justify"><b>Alluraa.com</b> is all about- <b>how India Shops</b> -there is always a trusted {{$root.INFLUENCER_TEXT}} who happily assists the buyers in making the right buying decisions.</p>
        <p class="text-justify"><b>Alluraa.com</b> is a unique platform which combines the best of assisted selling and carefully curated selection of high-quality products with the power of social interaction that connects customers across the country with well-known and upcoming brands.</p>
        <p class="text-justify">We at <b>Alluraa</b> strive to provide value and convenience to all our customers by offering a curated selection of high-quality products across a large variety of categories, including fashion, cosmetics, organic food, herbal care, etc. Our endeavor is to cater each customer’s diverse needs at attractive prices.</p>
        <p class="text-justify">With the popularization of smartphones and easy access to the internet, getting information about the products and learning about the available options is extremely easy. However, this is not always the case. The majority of the Indian population continues to buy based on the experiences of their friends and family. Our trustworthy {{$root.INFLUENCER_TEXT}}s act as a bridge between brands and customers, communicating with the language of their preference and using trust and goodwill to sell the products.</p>
        <p class="text-justify"><b>Alluraa</b> ensures increased penetration of the brands across the length and breadth of the country, and helps them gain immediate acceptance by creating a widespread and loyal customer base. This, in turn, allows the sellers in expanding their businesses to gain recognition and broader distribution.</p>
        <p class="text-justify">The Motto at <b>Alluraa</b> is – <b>My Shop My Business</b> - to provide every {{$root.INFLUENCER_TEXT}} with an unbiased opportunity to spread their wings and explore their true potential to the maximum with the help of a platform that enables them to become financially independent from the comfort of their home.</p>
      </b-container>
    </div>
    <bottom-footer></bottom-footer>
    <b-modal id="modal-status" hide-footer>
      <template v-slot:modal-title>
        Status
      </template>
      <div class="d-block text-center">
        <h5>{{modal.msg}}</h5>
      </div>
      <b-link class="mt-3 button btn-solid float-right" @click="$bvModal.hide('modal-status')">Close Me</b-link>
    </b-modal>
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Home",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  mounted(){
		this.init();
	},
  data() {
    return {
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customer:{
        prefix: 'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: ""
      },
      team:[
        {id:1, img:'', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that enable people from every stratum to earn an earnest livelihood.'},
        {id:2, img:'', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to enable the common man by leveraging technology and innovation.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Cosmetics','Electronics','Fashion','Herbal Products','Organic Food','Toys & baby','Other'],
      workarea_options: [],
      mainProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 110, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { blank: true, blankColor: '#b7b7b7', width: 300, height: 300, fluidGrow: true, class: 'm1' },
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 50
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 150
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
      }
    }
  },
  methods: {
    init(){
      var self = this;
      if(self.$route.params.param_role){
        self.customer.role = self.$route.params.param_role;
        self.$root.role = self.$route.params.param_role;
      //  self.customer.workarea = self['workarea_'+self.$route.params.param_role];
      }
      
      //alert(self.customer.role.replace('-',''));
      self.workarea_options = self['workarea_'+self.customer.role.replace('-','')];
      //self.customer.workarea = 
      //alert(self['workarea_'+self.customer.role]);
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
    submitRegistration(){
      var self = this;
      var valid = true;
      self.form_alert = [];
      if(self.customer.fullname == ''){
        //self.form_alert.push("Full name is required!");
        valid = false;
      }
      if(self.customer.email == '' && self.customer.mobile == '' ){
        //self.form_alert.push("Email or mobile is required!");
        valid = false;
      }
      if(self.terms_condition == 'not_accepted'){
        //self.modal.msg = "Please accept terms and condition!";
        //self.$bvModal.show('modal-status');
        self.form_alert.push("Terms and condition is required!");
        valid = false;
        //return;
      }
      var mobile = self.customer.mobile;
      if(mobile.length < 10){
        self.form_alert.push('Please add a valid mobile number!');
        valid = false;
      }
      if(self.customer.workarea == ''){
        valid = false;
      }
      
      if(!self.validateemail(self.customer.email)){
        self.form_alert.push('Please add a valid email!');
        self.form_alert.push('All fields are mandatory!');
        valid = false;
      }else{
        console.log('Valid email format!');
      }

      if(valid == false){
        return;
      }

      var workarea = '';
      if(self.customer.workarea == 'Other'){
        workarea = self.customer.other;
      }else{
        workarea = self.customer.workarea;
      }
      
			self.axios.post(self.$root.WEBURL+'registration', {
        prefix: self.customer.prefix,
        fullname: self.customer.fullname,
        email: self.customer.email,
        mobile: self.customer.mobile,
        role: self.customer.role,
        location: self.customer.location,
        workarea: workarea
			})
			.then(function (response) {
        
				if(response.data.error == 0 || response.data.error == '0'){
          if(self.customer.role == self.TYPE_SELLER){
            self.modal.msg = "Thanks for successfully registering your profile as a seller!";
          }else{
            self.modal.msg = "Thanks for successfully registering your profile as a sales advisor!";
          }
          
          self.customer = {
            prefix: 'mr',
            role: self.TYPE_SELLER,
            fullname: '',
            mobile: '',
            email: '',
            workarea: '',
            location: '',
            other: ''
          };
          self.$bvModal.show('modal-status');
				}else if(response.data.error == 1){
          self.modal.msg = "Registration Failed! Try agin later!";
					self.$bvModal.show('modal-status');
				}else if(response.data.error == 2){
          self.modal.msg = "Registration Failed! Email or mobile allready exist!";
					self.$bvModal.show('modal-status');
				}
			})
			.catch(function (error) {
				alert(error);
			});
    }
  },
  metaInfo() {
		return{
			title: 'Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
				{ name: 'description', content: 'alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
